module.exports = __webpack_public_path__ + "static/media/propiedades.177c7d5a.svg";